import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.promise.finally.js";
import { fetchData, addParamsToOpenApi } from '../../../../utils';
import Swiper, { Autoplay } from 'swiper';
import 'swiper/swiper-bundle.css';
Swiper.use([Autoplay]);
import { getParamsFromUrl, compareSv } from '@baidu/map-fe-utils';
import md5 from 'js-md5';
const {
  c: city = '0',
  os = '',
  sv = '',
  cuid = '',
  abtest = '',
  source = '',
  uid = '',
  unique_id = ''
} = getParamsFromUrl();
export default {
  name: 'content-task',
  data() {
    return {
      taskText: '',
      taskHasShow: false,
      taskObj: {
        task_id: '',
        task_type: 0,
        task_total: 0,
        task_done_num: 0,
        day: '',
        finish: 1,
        browse_time: 0
      },
      isLogin: false,
      swiper: null,
      showTask: false,
      // 是否展示任务组件
      status: ''
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isDark: {
      type: Boolean,
      default: false
    },
    tpSource: {
      type: String,
      default: ''
    },
    stdTag: {
      type: String,
      default: ''
    }
  },
  computed: {
    microBuryParams() {
      return {
        note_type: 'image',
        city_id: city,
        std_tag: this.stdTag,
        poi_uid: uid,
        tp: this.tpSource,
        uniqueid: unique_id,
        source
      };
    },
    initialIcon() {
      if (this.isDark) {
        return 'https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/getrewardall_detail.png';
      }
      return 'https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/redpocketshakeshake-2.png';
    },
    endIcon() {
      if (this.isDark) {
        return 'https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/getreward-2.png';
      }
      return 'https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/getreward-2.png';
    }
  },
  mounted() {
    setTimeout(() => {
      this.swiper = new Swiper('.task-swiper-container', {
        // 设置方向，水平方向(horizontal)或垂直方向(vertical)
        direction: 'vertical',
        loop: true,
        autoplay: true,
        autoplayDelay: 2000
      });
    }, 100); // 延迟 100 毫秒，确保 DOM 元素已渲染
  },

  methods: {
    /**
     * 获取任务信息
     *
     * @returns 返回 Promise 对象，解析为任务信息对象
     * 接口和circleTask任务组件是同一个接口，后面可以优化在外层组件请求接口判断，区分展示哪个组件
     */
    getTask() {
      const tokenCommonObj = this.getCommonToken({}, 'tzNW8faDDGTxOgl');
      const params = _objectSpread({
        source,
        from: 'post_detail_feed',
        city,
        os,
        sv
      }, tokenCommonObj);
      const url = '/feed-server/activity/task_init';
      return fetchData(url, {
        method: 'post',
        params
      }).then(res => {
        if (res.errno === 0) {
          const {
            task_total = 0,
            // 总任务数
            is_finish = 0,
            // 0未完成，1已完成
            sign_finish = 0,
            // 0签到任务没有完成   1签到任务已完成
            is_login = 0,
            // 1登录状态，0未登录状态
            is_progress = 0,
            // 0活动结束或者未开始，1活动进行中
            activity_type = 0 // 0：浏览时长，1：内容消费系统活动    内容消费系统新增字段
            // is_show_slide_down_bar = 0 // 0不展示下拉条，1展示下拉条
          } = res.data || {};
          this.showTask = is_progress === 1;
          // 有活动且内容消费系统活动
          if (is_progress !== 1) {
            this.showTask = false;
            this.$emit('showTask', false);
            return;
          }
          this.isLogin = is_login === 1;
          this.taskObj = res.data;
          // 未登录
          if (!this.isLogin) {
            this.status = 'noLogin';
            this.showTask = true;
            this.$emit('showTask', true);
            return;
          }
          if (activity_type === 1) {
            this.status = 'init';
            this.showTask = true;
            this.$emit('showTask', true);
          } else {
            this.showTask = false;
            this.$emit('showTask', false);
            return;
          }
          // 埋点
          if (!this.taskHasShow) {
            this.taskHasShow = true;
            this.showHandle();
          }
          const isFinished = Boolean(is_finish);
          const signFinish = Boolean(sign_finish);
          // 如果有任务
          if (task_total > 0) {
            // 如果任务已完成，直接展示完成状态
            if (isFinished && signFinish) {
              // 初始化时如果任务做完了，则直接显示完成态。
              this.status = 'finished';
            }
          }
        } else {
          this.showTask = false;
          this.$emit('showTask', false);
        }
      }).catch(err => {
        this.showTask = false;
        this.$emit('showTask', false);
        console.error(err, 'get task error');
      }).finally(() => {});
    },
    // 生成token参数
    getCommonToken(tokenObj = {}, salt, isLottery = false) {
      const {
        jstoken = '',
        ztoken = '',
        oztoken = ''
      } = tokenObj;
      const t = Math.floor(Date.now() / 1000);
      const {
        task_id,
        task_date,
        task_num
      } = this.taskObj;
      let token = '';
      if (isLottery) {
        token = `city=${city}&cuid=${cuid}&task_date=${task_date}&task_id=${task_id}&task_num=${task_num}&timestamp=${t}${salt}`;
      } else {
        token = `cuid=${cuid}&timestamp=${t}${salt}`;
      }
      token = md5(token);
      return {
        cuid,
        token,
        jstoken,
        ztoken,
        oztoken,
        abtest,
        timestamp: t
      };
    },
    /**
     * 点击任务按钮处理函数
     *
     * 添加点击行为日志，并跳转到百度地图的导航分享页面
     */
    clickTask() {
      this.sendLog(['MCEDse.MCEDpoiugc.NewMedia.microDetail.timeball.click'], this.microBuryParams);
      if (!this.isLogin) {
        window.taskLoginCallback = data => {
          if (+data) {
            this.isLogin = true;
            this.getTask();
          }
        };
        this.$emit('clickTask', 'taskLoginCallback');
        return;
      }
      const {
        prize_url = ''
      } = this.taskObj;
      if (prize_url) {
        const getParams = getParamsFromUrl();
        const params = _objectSpread(_objectSpread({}, getParams), {}, {
          from: 'post_detail_feed'
        });
        const jumpUrl = addParamsToOpenApi(prize_url, params);
        window.location.href = jumpUrl;
      }
    },
    showHandle() {
      this.$nextTick(() => {
        var _this$$refs;
        const obDom = (_this$$refs = this.$refs) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs.progressRef) === null || _this$$refs === void 0 ? void 0 : _this$$refs.$el;
        if (!obDom) {
          return;
        }
        // 曝光埋点
        this.$io.observe(obDom, () => {
          this.sendLog(['MCEDpoiugc.NewMedia.microDetail.timeball.show'], this.microBuryParams);
        });
      });
    },
    // 发送日志
    sendLog(actionID, params) {
      if (!window.MapLogReport || !actionID) {
        console.warn('MapLogReport或actionID 不存在');
        return;
      }
      window.MapLogReport.send(_objectSpread({
        da_src: actionID
      }, params));
    }
  },
  async created() {
    // 判断版本号是否大于等于20.16.50，如果不是则不执行后续代码
    if (compareSv(sv || '0', '20.16.50') < 0) {
      this.showTask = false;
      this.$emit('showTask', false);
      return;
    }
    await this.getTask();
  }
};